import "./index.scss";
// import {reuleaux} from "ldrs";

// reuleaux.register();

// Default values shown
import {hourglass} from "ldrs";

hourglass.register();

// Default values shown

function LoaderOverlay({desc}) {
  return (
    <>
      <div className="loader_overlay">
        <div class="loader3">
          <div class="circle1"></div>
          <div class="circle1"></div>
          <div class="circle1"></div>
          <div class="circle1"></div>
          <div class="circle1"></div>
        </div>
      </div>
    </>
  );
}

export default LoaderOverlay;
